import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './CountTopFilter.module.scss';

export function CountTopFilter(props) {
  const { name, display, loading, isActive, onClick, count = 0 } = props;

  return (
    <div className={cn(styles.container, isActive ? styles.active : '')} onClick={() => onClick(name)}>
      <p>{display}</p>
      {loading ? <span>&nbsp;&nbsp;</span> : <span>{count}</span>}
    </div>
  );
}

CountTopFilter.propTypes = {
  name: PropTypes.string.isRequired,
  display: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  count: PropTypes.number,
  loading: PropTypes.bool,
  isActive: PropTypes.bool,
};
